export default (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.2783 14.8858L14.1961 9.0094H15.6646L14.7468 14.8858H13.2783Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.0743 9.15271C19.6543 8.98517 19.2078 8.90026 18.7577 8.90232C17.3059 8.90232 16.2864 9.70357 16.2797 10.8467C16.268 11.6912 17.0106 12.1609 17.5662 12.4423C18.1219 12.7238 18.3272 12.9172 18.3272 13.1728C18.3272 13.5665 17.8683 13.7478 17.4461 13.7478C16.9689 13.7617 16.4957 13.6543 16.0678 13.4353L15.8742 13.342L15.6689 14.6613C16.1907 14.872 16.7459 14.9797 17.3059 14.9791C18.8478 14.9791 19.8507 14.1916 19.8624 12.9725C19.8624 12.3025 19.4752 11.7896 18.6292 11.3717C18.1169 11.1023 17.7949 10.921 17.7949 10.6464C17.7949 10.3719 18.0685 10.1439 18.6476 10.1439C19.0242 10.1318 19.3985 10.2086 19.7422 10.3684L19.8741 10.4306L20.0743 9.16134V9.15271Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.0221 12.8044C22.1439 12.459 22.6094 11.1587 22.6094 11.1587C22.6094 11.1587 22.7296 10.8134 22.803 10.5975L22.9048 11.1035C22.9048 11.1035 23.1835 12.5091 23.2385 12.8044H22.0221ZM23.8359 9.00536H22.6996C22.3491 9.00536 22.0838 9.1107 21.932 9.49233L19.751 14.8852H21.2912L21.5999 14.0045H23.4855C23.5272 14.21 23.6607 14.8852 23.6607 14.8852H25.0207L23.8359 9.01399V9.00536Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.0517 9.0094L10.6133 13.0174L10.4564 12.204C10.1894 11.2664 9.35675 10.2475 8.41895 9.74158L9.73721 14.8806H11.2891L13.5969 9.0094H12.0517Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.28174 9.0094H6.92054L6.89551 9.12855C8.73107 9.61552 9.95923 10.7915 10.4615 12.204L9.94588 9.50328C9.86077 9.12855 9.60213 9.02149 9.2784 9.0094H9.28174Z"
      fill="currentColor"
    />
    <path
      d="M33.0317 17.7692H0.473633V22.1538C0.473633 23.1734 1.27236 24 2.25764 24H31.2477C32.233 24 33.0317 23.1734 33.0317 22.1538V17.7692Z"
      fill="currentColor"
    />
    <path
      d="M31.2477 0H2.25764C1.27236 0 0.473633 0.826557 0.473633 1.84617V6.00004H33.0317V1.84617C33.0317 0.826557 32.233 0 31.2477 0Z"
      fill="currentColor"
    />
  </>
);
